(function () {
  function ready(fn) {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn);
    else fn();
  }

  ready(function () {
    var gallery = document.querySelector("media-gallery");
    if (!gallery) return;
    var list = gallery.querySelector(".product__media-list");
    var wrap = document.querySelector(".product__media-wrapper") || gallery;
    if (!list || !wrap) return;
    if (list.querySelectorAll(".product__media-item").length < 2) return;

    var prev = document.createElement("button");
    prev.className = "fc-nav fc-prev";
    prev.type = "button";
    prev.innerHTML = "‹";

    var next = document.createElement("button");
    next.className = "fc-nav fc-next";
    next.type = "button";
    next.innerHTML = "›";

    var lens = document.createElement("div");
    lens.className = "fc-lens";

    document.body.appendChild(prev);
    document.body.appendChild(next);
    wrap.appendChild(lens);

    function mainBox() {
      return list.querySelector(".product__media-item.is-active .product__media") ||
             list.querySelector(".product__media-item:first-child .product__media");
    }

        function placeNav() {
      var main = mainBox();
      if (!main) return;
      var r = main.getBoundingClientRect();
      var header = document.querySelector("sticky-header, .header-wrapper, .header");
      var headerH = header ? header.getBoundingClientRect().bottom : 70;
      var show = r.height > 40 && r.bottom > headerH + 20 && r.top < window.innerHeight - 80;
      prev.style.display = show ? "block" : "none";
      next.style.display = show ? "block" : "none";
      if (!show) return;
      var y = r.top + r.height / 2 - 20;
      prev.style.top = y + "px";
      next.style.top = y + "px";
      prev.style.left = r.left + 8 + "px";
      next.style.left = r.right - 48 + "px";
    }
        wrap.addEventListener("click", function (e) {
      if (window.innerWidth > 989) return;
      if (e.target.closest(".fc-nav")) return;
      var zoomBtn = wrap.querySelector(".product__media-icon, button.product__media-toggle, .product__media-zoom");
      if (zoomBtn) zoomBtn.click();
    });

    function setActive() {
      var els = list.querySelectorAll(".product__media-item");
      els.forEach(function (el) { el.classList.remove("is-active"); });
      if (els[0]) els[0].classList.add("is-active");
      placeNav();
    }

    function rotate(dir) {
      var els = list.querySelectorAll(".product__media-item");
      if (dir === 1) list.appendChild(els[0]);
      else list.insertBefore(els[els.length - 1], els[0]);
      setActive();
    }

    prev.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      rotate(-1);
    }, true);

    next.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      rotate(1);
    }, true);

    window.addEventListener("scroll", placeNav, { passive: true });
    window.addEventListener("resize", placeNav);
    placeNav();

    wrap.addEventListener("mousemove", function (e) {
      if (window.innerWidth < 750) return;
      var main = mainBox();
      if (!main) return;
      var img = main.querySelector("img");
      if (!img) return;
      var r = main.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) {
        lens.style.display = "none";
        return;
      }
      var x = e.clientX - r.left;
      var y = e.clientY - r.top;
      var size = 110;
      var zoom = 1.8;
      var wr = wrap.getBoundingClientRect();
      lens.style.display = "block";
      lens.style.left = r.left - wr.left + x - size / 2 + "px";
      lens.style.top = r.top - wr.top + y - size / 2 + "px";
      lens.style.backgroundImage = 'url("' + (img.currentSrc || img.src) + '")';
      lens.style.backgroundSize = r.width * zoom + "px " + r.height * zoom + "px";
      lens.style.backgroundPosition = -(x * zoom - size / 2) + "px " + -(y * zoom - size / 2) + "px";
    });

    wrap.addEventListener("mouseleave", function () {
      lens.style.display = "none";
    });
  });
    (function mobileInnerZoom() {
      var main = wrap.querySelector(".product__media-item.is-active .product__media") ||
                 wrap.querySelector(".product__media-item .product__media");
      if (!main) return;
      var img = main.querySelector("img");
      if (!img) return;
      main.style.overflow = "hidden";

      function zoomAt(x, y, r) {
        var px = ((x - r.left) / r.width) * 100;
        var py = ((y - r.top) / r.height) * 100;
        img.style.transformOrigin = px + "% " + py + "%";
        img.style.transform = "scale(2.2)";
      }
      function reset() {
        img.style.transform = "scale(1)";
      }

      main.addEventListener("touchstart", function (e) {
        if (window.innerWidth > 989) return;
        var t = e.touches[0];
        zoomAt(t.clientX, t.clientY, main.getBoundingClientRect());
      }, { passive: true });

      main.addEventListener("touchmove", function (e) {
        if (window.innerWidth > 989) return;
        var t = e.touches[0];
        zoomAt(t.clientX, t.clientY, main.getBoundingClientRect());
      }, { passive: true });

      main.addEventListener("touchend", reset);
      main.addEventListener("touchcancel", reset);
    })();
    (function mobileInnerZoom() {
      var main = wrap.querySelector(".product__media-item.is-active .product__media") ||
                 wrap.querySelector(".product__media-item .product__media");
      if (!main) return;
      var img = main.querySelector("img");
      if (!img) return;
      main.style.overflow = "hidden";

      function zoomAt(x, y, r) {
        var px = ((x - r.left) / r.width) * 100;
        var py = ((y - r.top) / r.height) * 100;
        img.style.transformOrigin = px + "% " + py + "%";
        img.style.transform = "scale(2.2)";
      }
      function reset() {
        img.style.transform = "scale(1)";
      }

      main.addEventListener("touchstart", function (e) {
        if (window.innerWidth > 989) return;
        var t = e.touches[0];
        zoomAt(t.clientX, t.clientY, main.getBoundingClientRect());
      }, { passive: true });

      main.addEventListener("touchmove", function (e) {
        if (window.innerWidth > 989) return;
        var t = e.touches[0];
        zoomAt(t.clientX, t.clientY, main.getBoundingClientRect());
      }, { passive: true });

      main.addEventListener("touchend", reset);
      main.addEventListener("touchcancel", reset);
    })();
})();